import { api } from "@/api/client";
import type { ApiListResponse } from "@/api/types";

export interface Subscriber {
  id: string;
  name: string | null;
  email: string;
  isActive: boolean;
  subscribedAt: string;
}

export interface SubscriberListQuery {
  page?: number;
  limit?: number;
  search?: string;
}

export const subscribersApi = {
  async list(query: SubscriberListQuery) {
    const { data } = await api.get<ApiListResponse<Subscriber>>("/subscribers", { params: query });
    return data;
  },
  async remove(id: string) {
    await api.delete(`/subscribers/${id}`);
  },
  async exportCsvUrl() {
    const response = await api.get("/subscribers/export", { responseType: "blob" });
    return URL.createObjectURL(response.data as Blob);
  },
};
